module.exports = __webpack_public_path__ + "img/choose-action-bar-2.7dcf42f0.png";